import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-spoolermachine',
  templateUrl: './spoolermachine.component.html',
  styleUrls: ['./spoolermachine.component.css']
})
export class SpoolermachineComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
